export const vatFieldOptions = [
  {
    label: '0,00 %',
    value: 0,
  },
  {
    label: '10,00 %',
    value: 10,
  },
  {
    label: '20,00 %',
    value: 20,
  },
]
